"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
exports.initialize = initialize;
const scriptjs = require(`scriptjs`);
const DATADOG_RUM_URL = 'https://www.datadoghq-browser-agent.com/datadog-rum-us.js';
function _initialize(config, userInfo, loadCallback) {
  scriptjs([DATADOG_RUM_URL], () => {
    if (window.DD_RUM) {
      window.DD_RUM.init({
        clientToken: config.token,
        applicationId: config.appId
      });
      loadCallback(userInfo, window.DD_RUM);
    }
  });
}
function initialize(config, userInfo) {
  const addGlobalContext = (userInfo, dd) => {
    for (let key in userInfo) {
      if (dd) {
        dd.addRumGlobalContext(key === 'preferred_username' ? 'userId' : key, userInfo[key]);
      }
    }
  };
  const dd = window.DD_RUM;
  if (dd && dd.getInternalContext()) {
    addGlobalContext(userInfo, dd);
  } else {
    _initialize(config, userInfo, addGlobalContext);
  }
}
var _default = exports.default = {
  initialize
};